module.exports = __webpack_public_path__ + "img/thumbnail-serenity.c9f395d6.jpg";